import { Component, OnInit, ViewChild } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { FieldWrapper, FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { ContextService } from '../../context.service';

@Component({
  selector: 'mutara-edit-wrapper',
  templateUrl: './edit-wrapper.component.html' ,
  styleUrls: ['./edit-wrapper.component.scss'],
  standalone: false
})
export class EditWrapperComponent extends FieldWrapper implements OnInit {
  @ViewChild(MatMenu) menuDefinition: MatMenu | undefined;
  wrapperOptions: FormlyFormOptions = {};
  fieldConfigs: FormlyFieldConfig[] = [];
  activateEditor: boolean = false;

  constructor(private context: ContextService) {
    super();
  }

  ngOnInit(): void {
    this.context.subscribeTo("formEditor", {
      next: (showEditor : boolean) => {
        this.activateEditor = showEditor;
        if ( this.field.props ) { this.field.props.readonly = showEditor; }
      }
    });
    let keyId = this.field.key;
    this.fieldConfigs = [
      { key: keyId + '-label', type: 'input', defaultValue: this.field.props?.label, props: { label: 'Label', change: ($event : any) => this._onChange($event) } },
      { key: keyId + '-desc', type: 'input', defaultValue: this.field.props?.label, props: { label: 'Description' } },
      { key: keyId + '-hint', type: 'input', defaultValue: this.field.props?.label, props: { label: 'Hint' } },
      { key: keyId + '-type', type: 'select', defaultValue: this.field.props?.label, props: { label: 'Type' } },
      { key: keyId + '-pos', type: 'input', defaultValue: this.field.props?.position, props: { label: 'Position #' } },
      { key: keyId + '-move', type: 'select', props: { label: 'Move to section ...', options: [{ label: 'Personal' }, { label: 'Contact' }, { label: 'Addresses' }, { label: 'Education' }] } },
      { key: keyId + '-speller', type: 'select', props: { label: 'Spell Dictionary...', options: [{ label: '' },] } },
    ];
  }

  _onChange(fieldConfig: FormlyFieldConfig) {
    console.log(fieldConfig);
  }

  menuEditor($event: any) {
    console.log('%O %O: %O', this.field.key, $event, this.menuDefinition);
  }
}